import type { RequestInfo } from '@ember-data/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

interface UserActionOptions {
  changelog?: string;
}

export function deactivateUserRequest(
  userId: string,
  options: UserActionOptions = {}
): RequestInfo {
  const { changelog } = options;

  const urlOptions: QueryUrlOptions = {
    identifier: { type: 'users' },
    op: 'query',
    resourcePath: 'users',
  };
  const url = buildBaseURL(urlOptions);
  const body = JSON.stringify({ data: { attributes: { _changelog: changelog } } });
  return {
    url: `${url}/${userId}/deactivate-user`,
    method: 'DELETE',
    body,
    cacheOptions: {
      [SkipCache]: true, // ← This tells CacheHandler to skip JSON:API validation
    },
  };
}

export function reactivateUserRequest(
  userId: string,
  options: UserActionOptions = {}
): RequestInfo {
  const { changelog } = options;

  const urlOptions: QueryUrlOptions = {
    identifier: { type: 'users' },
    op: 'query',
    resourcePath: 'users',
  };
  const url = buildBaseURL(urlOptions);
  const body = JSON.stringify({ data: { attributes: { _changelog: changelog } } });
  return {
    url: `${url}/${userId}/reactivate-user`,
    method: 'PATCH',
    body,
    cacheOptions: {
      [SkipCache]: true, // ← This tells CacheHandler to skip JSON:API validation
    },
  };
}

export function wellnessInfoRequest(userId: string): RequestInfo {
  const urlOptions: QueryUrlOptions = {
    identifier: { type: 'users' },
    op: 'query',
    resourcePath: 'users',
  };
  const url = buildBaseURL(urlOptions);
  return {
    url: `${url}/${userId}/user-profile?profile_key=UserProfileAttribute.WELLNESS_TRAIN`,
    method: 'GET',
    cacheOptions: {
      [SkipCache]: true, // ← This tells CacheHandler to skip JSON:API validation
    },
  };
}

export function recalculateWellnessRequest(userId: string): RequestInfo {
  const urlOptions: QueryUrlOptions = {
    identifier: { type: 'users' },
    op: 'query',
    resourcePath: 'users',
  };
  const url = buildBaseURL(urlOptions);
  const body = JSON.stringify({
    data: {
      type: 'profile-attributes',
      attributes: {},
      relationships: {
        user: {
          data: {
            type: 'users',
            id: userId,
          },
        },
      },
    },
  });
  return {
    url: `${url}/${userId}/user-wellness-train`,
    method: 'PATCH',
    body,
    cacheOptions: {
      [SkipCache]: true, // ← This tells CacheHandler to skip JSON:API validation
    },
  };
}

export function makeTasRecommendationRequest(applicationId: string): RequestInfo {
  const urlOptions: QueryUrlOptions = {
    identifier: { type: 'tas-applications' },
    op: 'query',
    resourcePath: 'tas-applications',
  };
  const url = buildBaseURL(urlOptions);
  const body = JSON.stringify({
    application_id: applicationId,
  });
  return {
    url: `${url}/${applicationId}/recommend`,
    method: 'POST',
    body,
    cacheOptions: {
      [SkipCache]: true, // ← This tells CacheHandler to skip JSON:API validation
    },
  };
}
